import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
export var useLocaleStore = create()(immer(function (set, get) {
  return {
    state: {
      currentLocale: 'GB'
    },
    actions: {
      updateLocale: function updateLocale(locale) {
        set(function (state) {
          state.state.currentLocale = locale;
        });
      }
    }
  };
}));